import React from "react";
import { Icon } from "@amzn/awsui-components-react";
import { SelectionLandingProps } from "./definitions";
import styles from "./style.module.scss";

const SelectionLanding: React.FC<SelectionLandingProps> = ({
  onSelect,
  isAnswersKbEnabled,
}) => {
  const handleKeyDown =
    (tab: "assistant" | "answers") =>
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onSelect(tab);
      }
    };

  return (
    <div className={styles.selectionContainer}>
      <Icon name="gen-ai" size="big" />
      <div className={styles.selectionTitle}>How can I help you?</div>
      <div
        className={styles.selectionCard}
        role="button"
        tabIndex={0}
        onClick={() => onSelect("assistant")}
        onKeyDown={handleKeyDown("assistant")}
      >
        <div className={styles.selectionCardTitle}>Gaia Assistant</div>
        <div className={styles.selectionCardDescription}>
          Ask about your audits, tasks, notices, or litigations
        </div>
      </div>
      {isAnswersKbEnabled && (
        <div
          className={styles.selectionCard}
          role="button"
          tabIndex={0}
          onClick={() => onSelect("answers")}
          onKeyDown={handleKeyDown("answers")}
        >
          <div className={styles.selectionCardTitle}>Answers</div>
          <div className={styles.selectionCardDescription}>
            Ask your knowledge base
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectionLanding;
